import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Row, Column } from '@narvar/nth-grid';
import Button from '@narvar/nth-button';
import { SemibigHeader } from '@narvar/nth-header';
import ReturnsModal from '../ReturnsModal';
import ModalSection from '../ReturnsModal/ModalSection';
import modalData from './modalData';

const mapStateToProps = ({ language }) => ({
  language,
});

const Disclaimer = ({ children }) => (
  <Row style={{ margin: '2rem auto' }}>
    <Column xs-columns={10} xs-column-offset={1}>
      <p style={{ color: '#7A7A7A', fontSize: '14px' }}>{children}</p>
    </Column>
  </Row>
);

const SubmitButton = styled(Button)`
  margin: 0 auto;
  padding: 15px;
`;

const ConfirmButton = ({ onConfirm, toggleOpen, children }) => (
  <Row style={{ margin: '1rem auto', maxWidth: '450px', fontSize: '1.25rem' }}>
    <SubmitButton
      big
      onClick={() => {
        onConfirm();
        toggleOpen(false);
      }}
      className="narvar-btn-primary"
    >
      {children}
    </SubmitButton>
  </Row>
);

const Wrapper = styled.div`
  padding: 2rem;
`;

const LearnMoreModal = ({ onConfirm, optionId, language }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const toggleOpen = (status) => setIsOpen(status || !isOpen);

  const { infoColumns, headerText, description, disclaimer, openText, confirm } = modalData({
    language,
    optionId,
  });

  return (
    <ReturnsModal {...{ toggleOpen, isOpen, openText, headerText }}>
      <Wrapper>
        {headerText && <SemibigHeader s={{ fontSize: '2rem' }}>{headerText}</SemibigHeader>}
        {description && (
          <p
            style={{ fontSize: '1.125rem', fontFamily: 'inherit', padding: '0 1rem' }}
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          />
        )}

        {infoColumns.length > 0 && (
          <Row style={{ padding: '1rem 2rem' }}>
            {infoColumns.map((info) => (
              <ModalSection {...info} key={info.title} colWidth={12 / infoColumns.length} />
            ))}
          </Row>
        )}

        <ConfirmButton
          {...{
            onConfirm,
            toggleOpen,
          }}
        >
          {confirm}
        </ConfirmButton>
        {disclaimer && <Disclaimer>{disclaimer}</Disclaimer>}
      </Wrapper>
    </ReturnsModal>
  );
};

Disclaimer.propTypes = {
  children: PropTypes.node.isRequired,
};

ConfirmButton.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  toggleOpen: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

LearnMoreModal.defaultProps = {
  brandCtaColor: '#000000',
};

LearnMoreModal.propTypes = {
  language: PropTypes.object.isRequired,
  onConfirm: PropTypes.func.isRequired,
  optionId: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(LearnMoreModal);
